import styled from 'styled-components';

import { ThemeDirection } from '@/core/constants/constants';

import {
  BodyMedium,
  Caption,
} from '../Typography/Typography.styles';
import { TextFieldSizes } from './TextField.types';

export const InputWrapper = styled.div`
  position: relative;
`;

export const Input = styled.input<{ $isError: boolean; $size: TextFieldSizes }>`
  ${BodyMedium}
  width: 100%;
  min-width: 100%;
  max-width: 100%;
  height: ${({ $size }) => ($size === TextFieldSizes.HUGE ? '64px' : '56px')};
  margin: 0;
  border: 1px solid
    ${({
    $isError,
    theme,
  }) => ($isError ? theme.colors.semantic.danger[500] : theme.colors.neutral[300])};
  padding: 12px 16px;
  color: ${({
    $isError,
    theme,
  }) => ($isError ? theme.colors.semantic.danger[500] : theme.colors.neutral[700])};
  font-family: var(--executive-website-regular-font-family);
  appearance: none;

  &::placeholder {
    color: ${({ theme }) => theme.colors.neutral[500]};
  }

  &:focus-visible {
    outline: 1px solid
      ${({
    $isError,
    theme,
  }) => ($isError ?
    theme.colors.semantic.danger[500] :
    theme.colors.neutral[300])};
  }
`;

export const FieldErrorMessage = styled.div`
  padding-left: 5px;
  color: ${({
    theme: {
      colors: { semantic },
    },
  }) => semantic.danger[500]};
  font-weight: 400;
  font-size: 13px;
`;

export const Label = styled.label<{ $isError: boolean }>`
  ${Caption};
  margin-bottom: 4px;
  color: ${({
    $isError,
    theme,
  }) => ($isError ? theme.colors.semantic.danger[500] : theme.colors.neutral[700])};
`;

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  width: 100%;
`;

export const ClearButton = styled.button`
  position: absolute;
  top: 16px;
  right: ${({ theme: { direction } }) => (direction === ThemeDirection.LTR ? '16px' : 'auto')};
  left: ${({ theme: { direction } }) => (direction === ThemeDirection.LTR ? 'auto' : '16px')};
  z-index: 2;
  display: inline-flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  align-self: center;
  border: none;
  padding: 0;

  &:not(:disabled) {
    &:active {
      opacity: 0.88;
    }
    cursor: pointer;
  }
  background-color: transparent;
`;
